import { render, staticRenderFns } from "./EditNew.vue?vue&type=template&id=ba421612&scoped=true&"
import script from "./EditNew.vue?vue&type=script&lang=js&"
export * from "./EditNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba421612",
  null
  
)

export default component.exports